import { Box, Stack, TextField, Typography } from "@mui/material";
import MDEditor from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";

// import { previewIndexStyle, requiredStyles } from "../question.style";
import { MobilePreviewcomponentMap } from "./MobilePreviewMap";
import { QuestionCard } from "./mobilePreview.style";

const MobQuestionBlock = ({ question, currentPage }: any) => {
  const Component = MobilePreviewcomponentMap[question.type];

  return (
    <Stack
      gap={2}
      sx={{
        height: "100%",
        overflowY: "hidden",
        px: "15px",
        "&:hover": {
          overflow: "auto",
        },
        "&::-webkit-scrollbar": {
          width: "4px",
        },
      }}
    >
      {/* {["statement", "summary"].includes(question.type) &&
      !question?.properties?.showIndex ? (
        <></>
      ) : (
        <Stack sx={previewIndexStyle}>
          {question?.properties?.displayNumber
            ? question?.properties?.displayNumber
            : currentPage}
        </Stack>
      )} */}
      <Box
      // sx={question?.properties?.required ? requiredStyles : {}}
      >
        <MDEditor.Markdown
          wrapperElement={{
            "data-color-mode": "light",
          }}
          source={question.labelMarkdown}
          rehypePlugins={[rehypeSanitize]}
          style={{ fontWeight: "400", backgroundColor: "#F2F2F7" }}
        />
      </Box>
      {Component && <Component key={question.id} currentQuestion={question} />}
      {!["statement", "summary"].includes(question.type) && (
        <Typography
          variant="subtitle1"
          sx={{
            textDecoration: "underline",
            ml: "auto",
          }}
        >
          Clear
        </Typography>
      )}

      {/* {question?.helperText && (
        <Typography variant="body1" sx={{ mb: 1 }}>
          {question?.helperText}
        </Typography>
      )} */}
      {question?.properties?.remarkText && (
        <Box sx={QuestionCard}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Enter Remark
          </Typography>
          <TextField
            fullWidth
            defaultValue={question?.properties?.remarkText}
            placeholder="Type here"
          />
        </Box>
      )}
    </Stack>
  );
};

export default MobQuestionBlock;
